import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import ENV_VARS from '@/config'
import { makeMainLayout } from '@/layouts/main'
import { HeaderTheme } from '@/features/Header'
import SponsoredListingsFeature from '@/features/SponsoredListings'
import Head from '@/components/head'

const { BASE_URL } = ENV_VARS

function SponsoredListings() {
  const { t } = useTranslation('landlords')

  return (
    <>
      <Head
        title={t('landlords:Advertise your rental listing | liv.rent')}
        description={t(
          `landlords:Get your rental listing in front of qualified tenants. Boost listing views, inquiries and applications with liv.rent's advertising solutions.`
        )}
        meta={{
          image: `${BASE_URL}/images/advertise_your_rental_listing.jpg`,
          imageAlt: t('landlords:advertise your rental listing on liv.rent')
        }}
        path="/landlords/sponsored-listings"
      ></Head>
      <SponsoredListingsFeature />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation', 'landlords']))
    }
  }
}
const headerConfig = {
  theme: HeaderTheme.TRANSPARENT,
  showNavItems: true,
  showSearch: false
}

SponsoredListings.Layout = makeMainLayout({ headerConfig })

export default SponsoredListings
